export default __webpack_public_path__ + "static/media/ibusinessmbl.870ea542.png";